export class EmpresaAfiliadaUsuario {
  idEmpresaAfiliada: number;
  idUsuario: number;
  idRegion: number;
  estatus: string;
  seleccionada: number;
}


export class EmpresaConfiguracionInicial {
  idConfiguracionInicial: number;
  idEmpresaAfiliada: number;
  inicio: number;
  configEmpresa?: number = 0;
  configWhatsapp?: number = 0;
  configProyectos?: number = 0;
  fechaHoraUM: string;
  idUsuarioUM: number;
}